import { render, staticRenderFns } from "./IndicationsHistoryList.vue?vue&type=template&id=e25984e8&scoped=true&"
import script from "./IndicationsHistoryList.vue?vue&type=script&lang=js&"
export * from "./IndicationsHistoryList.vue?vue&type=script&lang=js&"
import style0 from "./IndicationsHistoryList.vue?vue&type=style&index=0&id=e25984e8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e25984e8",
  null
  
)

export default component.exports